import { useMemo } from 'react';
import { useAccountDataQuery } from 'queries/account';
export const useAiAgentFeatureFlag = ()=>{
    const { data: accountData } = useAccountDataQuery();
    const accountMeta = accountData === null || accountData === void 0 ? void 0 : accountData.accountMeta;
    const hasAiAgentFeatures = useMemo(()=>{
        var _ref;
        var _accountMeta_features;
        return (_ref = accountMeta === null || accountMeta === void 0 ? void 0 : (_accountMeta_features = accountMeta.features) === null || _accountMeta_features === void 0 ? void 0 : _accountMeta_features.aiAgents) !== null && _ref !== void 0 ? _ref : false;
    }, [
        accountMeta === null || accountMeta === void 0 ? void 0 : accountMeta.features
    ]);
    return hasAiAgentFeatures;
};
